<template>
	<div>

	<!-- 卡片试图区域 -->
	<el-card>
		<el-row :gutter="20">
				<el-col :span="4">
					<el-button type="primary" @click="openAddmenu" >添加菜单</el-button>
					</el-col>
		</el-row>
		<!-- 菜单列表区域 -->
		 <el-table
		    :data="menulist"
			  border
			  stripe
			  row-key="pid"
			  border
				  >
			  <el-table-column
			    type="index"
			   >
			  </el-table-column>
		      <el-table-column
		        prop="label"
		        label="菜单名称">
		      </el-table-column>
			  <el-table-column
			    prop="indexPath"
			    label="菜单路由路径">
			  </el-table-column>
			  <el-table-column
			    label="操作">
				<template slot-scope="scope">
					<el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
					 	<el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.pid)"></el-button>
					   </el-tooltip>
					<el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
					 	<el-button type="danger" icon="el-icon-delete" size="mini" @click="removeMenuById(scope.row.pid)"></el-button>
					   </el-tooltip>
					</template>
			  </el-table-column>
		    </el-table>
	</el-card>
	<!-- 添加菜单的对话框 -->
	<el-dialog
	  title="添加菜单栏"
	  :visible.sync="addDialogVisible"
	  width="50%"
	  @close="addDialogClosed"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="addFormRules"
	 ref="addFormRef"
	 :model="addForm"
	 label-width="80px">
	   <el-form-item label="菜单名称" prop="label">
	     <el-input v-model="addForm.label"></el-input>
	   </el-form-item>
	   <el-form-item label="菜单路径" prop="indexPath">
	     <el-input v-model="addForm.indexPath"></el-input>
	   </el-form-item>
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="addDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="addMenu">确 定</el-button>
	  </span>
	</el-dialog>
	<!-- 修改菜单的对话框 -->
	<el-dialog
	  title="修改菜单"
	  :visible.sync="editDialogVisible"
	  width="50%"
	  @close="editDialogClosed"
	>
	  <!-- 内容主体区域 -->
	 <el-form
	 :rules="editFormRules"
	 ref="editFormRef"
	 :model="editForm"
	 label-width="80px">
	   <el-form-item label="菜单名称" prop="label">
	     <el-input v-model="editForm.label"></el-input>
	   </el-form-item>
	   <el-form-item label="菜单路径" prop="indexPath">
	     <el-input v-model="editForm.indexPath"></el-input>
	   </el-form-item>
	   </el-form>
	  <!-- 底部区域 -->
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="editDialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="editMenuInfo">确 定</el-button>
	  </span>
	</el-dialog>
		</div>
</template>

<script>
	export default{
		data(){
			return{
				menulist:[],
				//获取父级菜单
				fidmenulist:[],
				//控制添加菜单对话框的显示与隐藏
				addDialogVisible:false,
				//控制修改菜单对话框的显示与隐藏
				editDialogVisible:false,
				//添加用户的表单数据
				addForm:{
					label:'',
					indexPath:'',
				},
                //添加表单的验证规则对象
				addFormRules:{
					label:[
						{required:true,message:'请输入菜单栏名称',trigger:'blur'},
						{min:2,max:10,message:'菜单栏的长度在2~10字符之间',trigger:'blur'}
					],
					indexPath:[
						{required:true,message:'请输入菜单路径',trigger:'blur'},
						{min:2,max:20,message:'菜单路径的长度在2~10字符之间',trigger:'blur'}
					],
				},
				//查询到的菜单信息对象
				editForm:{},
				//修改表单的验证规则对象
				editFormRules:{
					label:[
						{required:true,message:'请输入菜单栏名称',trigger:'blur'},
						{min:2,max:10,message:'菜单栏的长度在2~10字符之间',trigger:'blur'}
					],
				indexPath:[
					{required:true,message:'请输入菜单路径',trigger:'blur'},
					{min:2,max:20,message:'菜单路径的长度在2~10字符之间',trigger:'blur'}
				],
				},
			}
		},
		created(){
			this.getMenuList()
		},
		methods:{
			async getMenuList(){
				const {data:res} = await this.$http.getAllMenu()
				if (res.status !==0){
	             return this.$message.error('获取菜单列表失败!')
				}
				this.menulist = res.data
        },
			openAddmenu(){
				this.addDialogVisible = true
			},
			//点击按钮，添加菜单
			addMenu(){
				this.$refs.addFormRef.validate(async valid =>{
              	if (!valid) return
				 const {data:res} = await this.$http.addMenu(this.addForm)
				if (res.status !==0){
					return this.$message.error('添加菜单失败!')
				}
				this.$message.success('添加菜单成功!')
				this.addDialogVisible = false
				this.getMenuList()
				})
			},
			//监听添加菜单对话框的关闭
			addDialogClosed(){
				this.$refs.addFormRef.resetFields()
			},
			//展示编辑菜单的对话框
			async showEditDialog(id){
				const {data:res} = await this.$http.byIdGetMenu(id)
				if (res.status !==0){
					return this.$message.error('查询菜单信息失败!')
				}
				 this.editForm = res.data
				 console.log(this.editForm)
				 this.editDialogVisible = true
			},
		//修改菜单信息并提交
		editMenuInfo(){
			this.$refs.editFormRef.validate(async valid =>{
			if (!valid) return
			const {data:res} = await this.$http.editMenu(this.editForm)
			if (res.status !==0){
				return this.$message.error('修改菜单失败!')
			}
			this.$message.success('修改菜单成功!')
			this.editDialogVisible = false
		    this.getMenuList()
			 })
		},
		//监听修改菜单对话框的关闭
		editDialogClosed(){
			this.$refs.editFormRef.resetFields()

		},
		//根据Id删除对应的菜单信息
		async removeMenuById(id){
			//弹框询问用户是否删除数据
			        const confirmResult = await this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        }).catch(err => err)
					if (confirmResult !== 'confirm'){
						return this.$message.info('已取消删除')
					}
					const {data:res} = await this.$http.delMenu(id)
					if (res.status !==0){
						return this.$message.error('删除菜单失败!')
					}
					this.$message.success('删除菜单成功!')
					this.getMenuList()
		},
		}
	}
</script>

<style lang="less" scoped>
</style>
